// extracted by mini-css-extract-plugin
export default {"favorate-button":"favorate-button_favorate-button__h9uwj","active":"favorate-button_active__H4+C6"};